import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessSummary } from '../services/businessService';

export const fetchBusinessSummary = createAsyncThunk(
  'businessSummary/fetchBusinessSummary',
  async ({ businessId, year }) => {
    const data = await getBusinessSummary(businessId, year);
    return data;
  }
);

const businessSummarySlice = createSlice({
  name: 'businessSummary',
  initialState: {
    revenue: 0,
    totalCustomers: 0,
    totalProjects: 0,
    retentionRate: 0,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessSummary.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBusinessSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.revenue = action.payload.revenue;
        state.totalCustomers = action.payload.total_customers;
        state.totalProjects = action.payload.total_projects;
        state.retentionRate = action.payload.retention_rate;
      })
      .addCase(fetchBusinessSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default businessSummarySlice.reducer;